import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vistoria-autonoma',
  templateUrl: './vistoria-autonoma.component.html',
  styleUrls: ['./vistoria-autonoma.component.scss']
})
export class VistoriaAutonomaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
